import { render, staticRenderFns } from "./lazyImg.vue?vue&type=template&id=dc1a56a6"
import script from "./lazyImg.vue?vue&type=script&lang=js"
export * from "./lazyImg.vue?vue&type=script&lang=js"
import style0 from "./lazyImg.vue?vue&type=style&index=0&id=dc1a56a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports